import type { ApiSourceLabelPair } from '@highimpact-frontend/api-types';

import { toSourceLabelKey } from '../api/sourceLabelKeys';

/** Builds a stable hash segment for source-label query keys. */
export function getSourceLabelPairsKey(
  pairs: readonly ApiSourceLabelPair[]
): string {
  return [...pairs]
    .map(
      (pair) =>
        `${pair.measure_point_id}:${pair.measure_type_id}`
    )
    .sort()
    .join(',');
}

export { toSourceLabelKey };
